import { render, staticRenderFns } from "./data-dialog.vue?vue&type=template&id=654760b4&scoped=true&"
import script from "./data-dialog.vue?vue&type=script&lang=js&"
export * from "./data-dialog.vue?vue&type=script&lang=js&"
import style0 from "./data-dialog.vue?vue&type=style&index=0&id=654760b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654760b4",
  null
  
)

export default component.exports